<h2>What do you want to do?</h2>
<shared-button-with-image
  headline="Buy a property"
  description="Explore mortgage options for a property you're planning to buy."
  imagePath="/assets/images/dialog-house-glass.png"
  contentStyleClass="bg-gray-5"
  [isSelected]="stepFormGroup.value.type === SmartSearchType.NEW_PROPERTY_MAXIMUM_PRICE"
  [showArrowIcon]="false"
  (click)="setValue(SmartSearchType.NEW_PROPERTY_MAXIMUM_PRICE)" />
<shared-button-with-image
  headline="Borrow more money"
  description="Look into borrowing more for any financial needs or home improvements."
  imagePath="/assets/images/dialog-stacked-coins.png"
  contentStyleClass="bg-gray-5"
  [isSelected]="stepFormGroup.value.type === SmartSearchType.MORTGAGE_BORROW_MORE"
  [showArrowIcon]="false"
  (click)="setValue(SmartSearchType.MORTGAGE_BORROW_MORE)" />
<shared-button-with-image
  headline="Pay my mortgage faster"
  description="Find ways to pay off your mortgage sooner."
  imagePath="/assets/images/dialog-pocket-watch.png"
  contentStyleClass="bg-gray-5"
  [isSelected]="stepFormGroup.value.type === SmartSearchType.MORTGAGE_PAY_FASTER"
  [showArrowIcon]="false"
  (click)="setValue(SmartSearchType.MORTGAGE_PAY_FASTER)" />
<shared-button-with-image
  headline="Speak to an expert"
  description="Get personalised advice for your mortgage needs."
  imagePath="/assets/images/dialog-directions.png"
  contentStyleClass="bg-gray-5"
  [isSelected]="stepFormGroup.value.type === SmartSearchType.SPEAK_TO_AN_EXPERT"
  [showArrowIcon]="false"
  (click)="setValue(SmartSearchType.SPEAK_TO_AN_EXPERT)" />
<cp-stepper
  class="stepper"
  [forwardButtonEnabled]="stepFormGroup.valid"
  [hideProgressBar]="true"
  [showForwardButtonIcon]="false"
  [hideBackButton]="true"
  [showSkipButton]="false"
  (forward)="emitNextClicked()" />
